console.log('js/showcard_slideshow.js -> v0.1.0');

$(function(){
  var windowWidth = $(window).width();

	function card_slideshow(el){
		var imgs = [];
		var el = $(el).find('.wrapper-img');
		var imgs = $(el).find('img');
		var imgIndex = 0;
		clearInterval(window.card_slideshow_interval);
		window.card_slideshow_interval = setInterval(function(){
			imgIndex++;
			if($(imgs[imgIndex]).attr('src') == undefined){
				imgIndex = 0;
			};
			var src = $(imgs[imgIndex]).attr('src');
			$(el).css("background-image", "url("+src+")");
		},1000);
	};

    $('.showcards .showcard').hover(
        function() {
            if (windowWidth > 1024) {				
				let wrapper = $(this).find('.wrapper-img');
				let imageURLs = wrapper.data('slideshow-images').split(',');

				if(wrapper.attr('data-images-added') == undefined) {
					$(this).addClass('card_slideshow')
					wrapper.attr('data-images-added', "true") ;
					for(let i = 1; i < Math.min(6, imageURLs.length); i++) {
						$(wrapper).append('<img class="hide" src="' + imageURLs[i] + '">');
					}

					$(wrapper).append('<img class="hide" src="' + imageURLs[0] + '">');
				}

				card_slideshow(this);				 
            }
        },

        function() {
            clearInterval(window.card_slideshow_interval);
        }
    );

});
